module.exports = __webpack_public_path__ + "static/img/no-list-icon.42e3150e.png";